import { render, staticRenderFns } from "./CAForm.vue?vue&type=template&id=d21edfc6&"
import script from "./CAForm.vue?vue&type=script&lang=js&"
export * from "./CAForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports